import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { Dialog } from '@avanta/shared/components/ui/Dialog';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { useDeletePatient } from '@avanta/shared/hooks/useDeletePatient';

export const DeleteAccountDialog = ({
  userId,
  redirect = true,
}: {
  userId?: string;
  redirect?: boolean;
}): React.ReactElement => {
  const { mutate: deletePatient, isPending } = useDeletePatient();
  const { hideDialog } = useDialogContext();
  const { t } = useTranslation(LOCIZE_NS.PROFILE);

  const handleDeleteAccount = (): void => {
    if (!userId) {
      return;
    }

    deletePatient(
      { userId, redirect },
      {
        onSuccess: () => {
          hideDialog();
          toast.success(t('DeleteAccount.success'));
        },
        onError: () => {
          toast.error(t('DeleteAccount.error'));
        },
      }
    );
  };

  return (
    <Dialog
      title={t('DeleteAccountDialog.heading')}
      description={t('DeleteAccountDialog.body')}
      secondaryAction={{
        label: t('DeleteAccountDialog.cancel'),
        variant: 'terciary',
      }}
      primaryAction={{
        label: t('DeleteAccountDialog.confirm'),
        action: handleDeleteAccount,
        variant: 'terciary',
        isLoading: isPending,
        className: 'text-red-500 hover:border-red-600 hover:bg-red-100',
      }}
      open
      hideClose
    />
  );
};
